import { useRouter } from "next/router";
import SignIn from "../../components/SignIn";
import React from "react";
import { getUrlParam } from "utils/url-param-utils";

export default function SignInPage(): JSX.Element {
  const inviteId = getUrlParam(window, "invite");
  const router = useRouter();
  let errorMsg = router.query.errorMsg ?? "";
  if (typeof errorMsg !== "string") {
    errorMsg = "";
  }

  return <SignIn isSignUp={false} inviteId={inviteId} errorMsg={errorMsg} />;
}
